import React, { Component } from 'react'
import style from './style.css'

class FloatBox extends Component {
    constructor(props) {
        super(props)

        this.state = {
            active: false
        }

        this.show = this.show.bind(this)
        this.hide = this.hide.bind(this)
        this.toggle = this.toggle.bind(this)

        
    }
    componentDidMount() {
        this.eventListener = function(evt) {
            this.hide()
        }.bind(this)

        window.addEventListener('click', this.eventListener)
    }
    componentWillUnmount(){
        window.removeEventListener('click', this.eventListener)
    }

    show() {
        this.setState({
            active: true
        })
    }

    hide() {
        this.setState({
            active: false
        })
    }

    toggle(e) {
        this.ignoreClose(e)
        if(this.state.active)
            this.hide()
        else
            this.show()

    }

    ignoreClose(e) {
        e.stopPropagation()
    }

    render() {

        return (
            <div className={`${style.floatBox} ${(this.state.active) ? style.active : null }`} onClick={this.ignoreClose}>
                <span
                className={style.arrow}
                style={{
                    left: this.props.arrowLeft || '',
                    right: this.props.arrowRight || null
                }}
                >&#9830;</span>
                {this.props.children}
            </div>
        )
    }
}

export default FloatBox


// WEBPACK FOOTER //
// ./src/components/atoms/FloatBox/index.js